import { useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Spinner,
} from "reactstrap";
import { Editor } from "react-draft-wysiwyg";
import { SingleDatePicker } from "react-dates";
import { useMutation, useQuery } from "@apollo/client";
import { TimePicker } from "antd";
import ReactGPicker from "react-gcolor-picker";

import PerfectScrollbar from "react-perfect-scrollbar";
import draftToHtml from "draftjs-to-html";
import Cookies from "js-cookie";
import moment from "moment";
import gql from "graphql-tag";

import {
  uploadIcon,
  rewardIcon,
  calenderIcon,
  timeIcon,
  timeLimiIcon,
  PlatformSubmit,
  qrCodeIcon,
  copyIcon,
  editIcon,
  dropdownIcon,
} from "../../../Shared/SVGs/Shared";
import { removeQueryParams } from "../../../utilities";
import { updateCampaignFields, updateCampaignState } from "../CampaignActions";
import {
  convertToRaw,
  EditorState,
  convertFromHTML,
  ContentState,
} from "draft-js";

import Step4EditModal from "./Step4EditModal";
import toolbar from "../../../utility/toolbar";
import FormStep4QRModal from "./FormStep4QRModal";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Step4InfoModal from "./Step4InfoModal";
import toolbarTerms from "../../../utility/toolbarTerms";
import toolbarHashtag from "../../../utility/toolbarHashtag";
import QrCodeModal from "../../Video/Components/Campaign/QrCodeModal";

import youtube from "@src/assets/images/vyrill/reports/youtube_icon.png";
import tiktok from "@src/assets/images/vyrill/icons/tiktok_icon.png";
import instagram from "@src/assets/images/vyrill/icons/instagram_icon.png";
import upload from "@src/assets/images/vyrill/icons/upload_icon.png";
import googledrive from "@src/assets/images/vyrill/icons/google_drive_icon.png";
import dropbox from "@src/assets/images/vyrill/icons/dropbox_icon.png";

const platformData = [
  { name: "YouTube", icon: youtube },
  { name: "TikTok", icon: tiktok },
  { name: "Instagram", icon: instagram },
  { name: "GoogleDrive", icon: googledrive },
  { name: "Dropbox", icon: dropbox },
  { name: "Upload", icon: upload },
];

const GET_PRESIGNED_URL = gql`
  query GetPresignedURL($fileName: String!) {
    getPresignedURL(fileName: $fileName)
  }
`;

const CREATE_CAMPAIGN_MUTATION = gql`
  mutation MyMutation($campaign: clipupInput!) {
    createCampaign(campaign: $campaign) {
      _id
      logo_url
      bannerRenderAs
      name
      generate_qr
      banner_url
      manufacturer {
        _id
        name
      }
      products {
        _id
        name
      }
    }
  }
`;

const FormStep4 = ({
  editable,
  editHandler,
  isColorPickerOpen,
  setIsColorPickerOpen,
}) => {
  const [qrModal, setQrModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [qrmodal, setQrmodal] = useState(false);
  const [focused, setFocused] = useState(null);
  const [dropdownOpen1, setDropdownOpen1] = useState(false);
  const [isColorPickerButton, setIsColorPickerButton] = useState(false);
  const [isColorPickerButtonText, setIsColorPickerButtonText] = useState(false);
  const handleTimeTypeSelect = (option) => {
    dispatch(updateCampaignFields({ campaign_video_length_type: option }));
    setDropdownOpen1(false);
  };
  const toggleTimeDropdown = () => setDropdownOpen1(!dropdownOpen1);
  const form = useSelector((state) => state.campaign_states.form);
  const [date, setDate] = useState(
    form.end_date ? moment(form.end_date) : null
  );
  console.log(date);
  const end_time = useSelector((state) => state.campaign_states.form.end_time);
  const terms_and_conditions_editor_state = useSelector(
    (state) => state.campaign_states.form.terms_and_conditions_editor_state
  );
  const description_editor_state = useSelector(
    (state) => state.campaign_states.form.description_editor_state
  );

  const headline_editor_state = useSelector(
    (state) => state.campaign_states.form.headline_editor_state
  );
  const hashtag_editor_state = useSelector(
    (state) => state.campaign_states.form.hashtag_editor_state
  );
  const brand_instruction_editor_state = useSelector(
    (state) => state.campaign_states.form.brand_instruction_editor_state
  );

  const campaign_video_length_type = useSelector(
    (state) => state.campaign_states.form.campaign_video_length_type
  );
  const showCampaignStep = useSelector(
    (state) => state.videoPageStates.campaignsState.showCampaignStep
  );
  const campaign_response = useSelector(
    (state) => state.campaign_states.campaign_response
  );

  const selectedPlatformData = platformData.filter((platform) =>
    form?.campaign_upload_platform.includes(platform.name)
  );
  const campaignUrl = `${process.env.REACT_APP_CAMPAGIN_URL}/form/${campaign_response?._id}/landing`;
  const handleCloseQr = () => setQrmodal(false);
  const toggle = () => {
    setOpen(false);
  };
  const toggleQrModal = () => setQrModal(true);
  const closeQrModal = () => {
    setQrModal(false);
  };

  const pickerRef = useRef(null);
  const handleClickOutside = (event) => {
    if (pickerRef.current && !pickerRef.current.contains(event.target)) {
      setIsColorPickerOpen(false);
      setIsColorPickerButton(false);
      setIsColorPickerButtonText(false);
    }
  };
  useEffect(() => {
    if (isColorPickerOpen || isColorPickerButton || isColorPickerButtonText) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isColorPickerOpen, isColorPickerButton, isColorPickerButtonText]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setDate(form.end_date);
  }, [form.end_date]);

  const handleCopyClick = () => {
    setCopied(!copied);
    navigator.clipboard.writeText(campaignUrl);
    setTimeout(() => {
      setCopied(false);
    }, 500);
  };
  const handleQrClick = () => {
    dispatch(updateCampaignState({ activeStep: 5 }));
  };

  const handleDateChange1 = (newDate) => {
    setDate(newDate);
    dispatch(updateCampaignFields({ end_date: newDate, ongoing: false }));
  };
  const handleFocusChange = ({ focused }) => {
    setFocused(focused);
  };

  const [
    createCampaign,
    { data: CampaignData, loading: createCampaignLoading, error },
  ] = useMutation(CREATE_CAMPAIGN_MUTATION);

  const { refetch } = useQuery(GET_PRESIGNED_URL, {
    skip: true,
  });

  const handleSubmit = async () => {
    setLoading(true);
    const {
      campaign_headline,
      campaign_hashtag,
      campaign_brand_name,
      campaign_brand_image,
      campaign_reward,
      start_date,
      end_date,
      start_time,
      end_time,
      campaign_timezone,
      products,
      ongoing,
      campaign_video_limit,
      campaign_allow_rating,
      campaign_video_length,
      terms_and_conditions,
      campaign_description,
      campaign_reward_type,
      campaign_banner_image_file,
      campaign_banner_image_preview,
      image_dimensions,
      description_editor_state,
      terms_and_conditions_editor_state,
      brand_instruction,
      brand_instruction_editor_state,
      campaign_video_length_type,
      campaign_headline_editor,
      campaign_hashtag_editor,
      headline_editor_state,
      hashtag_editor_state,
      preview_color_change,
      campaign_button_color,
      campaign_button_text_color,
      campaign_upload_platform,
    } = form;
    try {
      let serializedContentDesc = null;
      let serializedContentBrand = null;
      let serializedContentHashtag = null;
      let serializedContentHeadline = null;
      let serializedContentTerm = null;

      if (description_editor_state) {
        const rawContentStateDesc = convertToRaw(
          description_editor_state.getCurrentContent()
        );
        serializedContentDesc = JSON.stringify(rawContentStateDesc);
      }

      if (headline_editor_state) {
        const rawContentStateHead = convertToRaw(
          headline_editor_state.getCurrentContent()
        );
        serializedContentHeadline = JSON.stringify(rawContentStateHead);
      }

      if (hashtag_editor_state) {
        const rawContentStateHash = convertToRaw(
          hashtag_editor_state.getCurrentContent()
        );
        serializedContentHashtag = JSON.stringify(rawContentStateHash);
      }

      if (brand_instruction_editor_state) {
        const rawContentStateBrand = convertToRaw(
          brand_instruction_editor_state.getCurrentContent()
        );
        serializedContentBrand = JSON.stringify(rawContentStateBrand);
      }

      if (terms_and_conditions_editor_state) {
        const rawContentStateTerm = convertToRaw(
          terms_and_conditions_editor_state.getCurrentContent()
        );
        serializedContentTerm = JSON.stringify(rawContentStateTerm);
      }
      const newProducts = products
        ?.filter((product) => product?.__isNew__)
        .map((product) => product?.label);

      const formattedStartTime = start_time.format("HH:mm");
      const formattedEndTime = end_time && end_time.format("HH:mm");

      const formattedStartDate = moment(start_date).set({
        hour: start_time.hour(),
        minute: start_time.minute(),
      });

      const formattedEndDate = ongoing
        ? false
        : moment(end_date).set({
            hour: end_time.hour(),
            minute: end_time.minute(),
          });

      let campaignBannerImage = campaign_banner_image_preview || "";

      if (campaign_banner_image_file) {
        const { data: urlData } = await refetch({
          fileName: campaign_banner_image_file.name,
        });

        // Upload File to preassigned URL
        const uploadImageResponse = await fetch(urlData.getPresignedURL, {
          method: "PUT",
          headers: {
            "Content-Type": campaign_banner_image_file.type,
          },
          body: campaign_banner_image_file,
        });

        if (!uploadImageResponse.ok) {
          setLoading(false);
          throw new Error("Failed to upload image");
        }

        campaignBannerImage = removeQueryParams(urlData.getPresignedURL);
      }

      const campaignData = {
        description_editor_state: serializedContentDesc,
        brand_instruction_editor_state: serializedContentBrand,
        headline_editor_state: serializedContentHeadline,
        hashtag_editor_state: serializedContentHashtag,
        terms_and_conditions_editor_state: serializedContentTerm,
        status: "",
        campaign_banner_image: campaignBannerImage,
        campaign_hashtag,
        campaign_brand_image,
        campaign_brand_name,
        campaign_description,
        campaign_upload_platform,
        brand_instruction,
        campaign_headline_editor,
        campaign_hashtag_editor,
        campaign_headline,
        preview_color_change,
        campaign_button_color,
        campaign_button_text_color,
        campaign_product: "campaign_product",
        campaign_reward,
        campaign_reward_type,
        campaign_timezone,
        manufacturer: {
          _id: Cookies.get("bId"),
          name: campaign_brand_name,
        },
        products: products
          ?.filter((product) => !product?.__isNew__)
          .map((product) => ({
            _id: product?.value,
            name: product?.label,
          })),
        ...(newProducts?.length > 0 && { newProducts }),
        start_date: formattedStartDate,
        start_time: formattedStartTime,
        ...(ongoing ? {} : { end_date: formattedEndDate }),
        ongoing,
        end_time: formattedEndTime,
        terms_and_conditions,
        ...(campaign_video_limit > 0 && { campaign_video_limit }),
        campaign_allow_rating,
        campaign_video_time_limit: `${campaign_video_length}`,
        campaign_video_length_type,
        descriptionRenderAs: "html",
        termAndConditionRenderAs: "html",
        bannerRenderAs: image_dimensions,
      };

      const { data: response } = await createCampaign({
        variables: { campaign: campaignData },
      });

      if (response) {
        setLoading(false);
        setOpen(false);
        toggleQrModal();
        dispatch(
          updateCampaignState({ campaign_response: response.createCampaign })
        );
        dispatch(
          updateCampaignFields({
            campaign_headline: "",
            campaign_hashtag: "",
            campaign_brand_name: "",
            campaign_product: "",
            campaign_banner_image: "",
            campaign_banner_image_file: null,
            productimageURL: "",
            campaign_description: "",
            campaign_reward: "",
            end_date: null,
            campaign_upload_platform: [],
            time: "",
            start_date: moment(),
            start_time: "",
            end_time: "",
            campaign_timezone: "GMT-07:00 (Pacific Daylight Time)",
            currentTime: "",
            campaign_reward_type: "",
            ongoing: false,
            products: [],
            campaign_video_limit: 200,
            campaign_video_length: "",
            campaign_allow_rating: false,
            terms_and_conditions: "",
            image_dimensions: "Fit",
            description_editor_state: null,
            brand_instruction_editor_state: null,
            terms_and_conditions_editor_state: null,
            campaign_video_length_type: "",
          })
        );
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onDrop = (acceptedFiles) => {
    const selectedImage = acceptedFiles[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      dispatch(
        updateCampaignFields({ campaign_banner_image_file: selectedImage })
      );
    };

    if (selectedImage) {
      reader.readAsDataURL(selectedImage);
      dispatch(
        updateCampaignFields({
          campaign_banner_image_preview: URL.createObjectURL(selectedImage),
          // campaign_banner_image: reader.result,
        })
      );
    }
  };
  const handleTimeChange1 = (time) => {
    dispatch(updateCampaignFields({ end_time: time }));
  };
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const productimage = (
    <>
      {editable ? (
        <div className="mb-2" {...getRootProps()}>
          <input {...getInputProps()} />
          <div style={{ width: "600px", height: "365px" }}>
            {form.campaign_banner_image_preview ? (
              <>
                <img
                  src={form.campaign_banner_image_preview}
                  alt="Uploaded"
                  style={{
                    background: "black",
                    border: "1px solid #23BBB8",
                    width: "600px",
                    height: "365px",
                    objectFit:
                      form?.image_dimensions === "Fill"
                        ? "cover"
                        : form?.image_dimensions === "Fit"
                        ? "contain"
                        : "contain",
                  }}
                />
                <div style={{ width: "350px", height: "0px" }}>
                  <p className="drop-text">
                    <div className="drop-logo">{uploadIcon} </div>Drag & Drop
                    file or Browse
                  </p>
                </div>
              </>
            ) : (
              <div>
                <img
                  src={require(`@src/assets/images/dropzoneimage.png`).default}
                  alt=""
                  style={{ width: "600px" }}
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div>
          <img
            src={
              form.campaign_banner_image_preview ||
              require("@src/assets/images/campaign-default.png").default
            }
            alt=""
            style={{
              background: "black",
              border: "1px solid #23BBB8",
              width: "599px",
              height: "365px",
              objectFit:
                form?.image_dimensions === "Fill"
                  ? "cover"
                  : form?.image_dimensions === "Fit"
                  ? "contain"
                  : "contain",
            }}
          />
        </div>
      )}
    </>
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      if (form.campaign_headline_editor === "") {
        const headlineBlocksFromHTML = convertFromHTML(form?.campaign_headline);
        const headlineState = ContentState.createFromBlockArray(
          headlineBlocksFromHTML.contentBlocks,
          headlineBlocksFromHTML.entityMap
        );
        dispatch(
          updateCampaignFields({
            headline_editor_state: EditorState.createWithContent(headlineState),
            campaign_headline_editor: form?.campaign_headline,
          })
        );
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [
    campaign_response?._id,
    form?._id,
    form.campaign_headline_editor,
    dispatch,
  ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (form.campaign_hashtag_editor === "") {
        const hashtagBlocksFromHTML = convertFromHTML(form?.campaign_hashtag);
        const hashtagState = ContentState.createFromBlockArray(
          hashtagBlocksFromHTML.contentBlocks,
          hashtagBlocksFromHTML.entityMap
        );
        dispatch(
          updateCampaignFields({
            hashtag_editor_state: EditorState.createWithContent(hashtagState),
            campaign_hashtag_editor: form?.campaign_hashtag,
          })
        );
      }
    }, 2000);
    return () => clearTimeout(timer);
  }, [
    campaign_response?._id,
    form?._id,
    form.campaign_hashtag_editor,
    dispatch,
  ]);

  const onColorChange = (value) => {
    dispatch(updateCampaignFields({ preview_color_change: value }));
  };
  const onButtonColorChange = (value) => {
    dispatch(updateCampaignFields({ campaign_button_color: value }));
  };
  const onButtonTextColorChange = (value) => {
    dispatch(updateCampaignFields({ campaign_button_text_color: value }));
  };

  const handleContentStateChange = (contentState) => {
    dispatch(
      updateCampaignFields({ campaign_description: draftToHtml(contentState) })
    );
  };

  const handleEditorStateChange = (editorState) => {
    dispatch(updateCampaignFields({ description_editor_state: editorState }));
  };

  const handleTermsContentState = (contentState) => {
    dispatch(
      updateCampaignFields({ terms_and_conditions: draftToHtml(contentState) })
    );
  };
  const handleTermsEditorState = (editorState) => {
    dispatch(
      updateCampaignFields({ terms_and_conditions_editor_state: editorState })
    );
  };
  const handleBrandContentStateChange = (contentState) => {
    dispatch(
      updateCampaignFields({ brand_instruction: draftToHtml(contentState) })
    );
  };

  const handleBrandEditorStateChange = (editorState) => {
    dispatch(
      updateCampaignFields({ brand_instruction_editor_state: editorState })
    );
  };

  const handleHeadlineEditorStateChange = (editorState) => {
    dispatch(updateCampaignFields({ headline_editor_state: editorState }));
  };
  const handleHeadlineContentStateChange = (contentState) => {
    const blocks = contentState?.blocks;
    const plainText = blocks?.map((block) => block?.text).join(" ");
    dispatch(
      updateCampaignFields({
        campaign_headline_editor: draftToHtml(contentState),
        campaign_headline: plainText,
      })
    );
  };

  const handleHashtagEditorStateChange = (editorState) => {
    dispatch(updateCampaignFields({ hashtag_editor_state: editorState }));
  };
  const handleHashtagContentStateChange = (contentState) => {
    const blocks = contentState?.blocks;
    const plainText = blocks?.map((block) => block?.text).join(" ");
    dispatch(
      updateCampaignFields({
        campaign_hashtag_editor: draftToHtml(contentState),
        campaign_hashtag: plainText,
      })
    );
  };

  const headline = (
    <>
      {editable ? (
        <div className="mt-3 mb-1">
          <Editor
            editorState={headline_editor_state}
            toolbarClassName="editor-toolbar editor-toolbar-headline"
            wrapperClassName="editor-wrapper-headline"
            editorClassName="editor-text-area-style-headline"
            onEditorStateChange={handleHeadlineEditorStateChange}
            onContentStateChange={handleHeadlineContentStateChange}
            toolbar={toolbarTerms}
            // localization={localization}
            // id="campaign_description"
            // stripPastedStyles
          />
        </div>
      ) : (
        <>
          {form.campaign_headline_editor ? (
            <div
              className="preview-headline"
              style={{ color: "white" }}
              dangerouslySetInnerHTML={{
                __html: form.campaign_headline_editor,
              }}
            />
          ) : (
            <div className="preview-headline" style={{ color: "white" }}>
              {form.campaign_headline}
            </div>
          )}
        </>
      )}
    </>
  );

  const hashtags = (
    <>
      {editable ? (
        <div className="mt-3 mb-3">
          <Editor
            editorState={hashtag_editor_state}
            toolbarClassName="editor-toolbar right-toolbar"
            wrapperClassName="editor-wrapper-hashtag-step-4"
            editorClassName="editor-text-area-style-hashtag-step-4"
            onEditorStateChange={handleHashtagEditorStateChange}
            onContentStateChange={handleHashtagContentStateChange}
            toolbar={toolbarHashtag}
          />
        </div>
      ) : (
        <>
          {form.campaign_hashtag_editor ? (
            <div
              className="hash-tags"
              dangerouslySetInnerHTML={{ __html: form.campaign_hashtag_editor }}
            />
          ) : (
            <div className="hash-tags">{form.campaign_hashtag}</div>
          )}
        </>
      )}
    </>
  );

  const discriptions = (
    <>
      {editable ? (
        <div className="campaign-discription">
          <div className="campaign-description-title">Campaign Description</div>
          <Editor
            editorState={description_editor_state}
            toolbarClassName="editor-toolbar"
            wrapperClassName="editor-wrapper-description"
            editorClassName="editor-text-area-style-description"
            onEditorStateChange={handleEditorStateChange}
            onContentStateChange={handleContentStateChange}
            toolbar={toolbar}
          />
        </div>
      ) : (
        <div className="campaign-discription">
          <div
            className="text"
            style={{
              paddingTop: form?.campaign_description !== "" && "26px",
            }}
          >
            {form?.campaign_description !== "" && "Campaign Description"}
          </div>
          <div
            style={{
              padding: form?.campaign_description !== "" && "30px 15px",
            }}
            dangerouslySetInnerHTML={{ __html: form?.campaign_description }}
          />
        </div>
      )}
    </>
  );

  const brandInstructions = (
    <>
      {editable ? (
        <div className="mb-1 campaign-discription">
          <div className="campaign-description-title">Brand Instructions</div>
          <Editor
            editorState={brand_instruction_editor_state}
            toolbarClassName="editor-toolbar"
            wrapperClassName="editor-wrapper-brand"
            editorClassName="editor-text-area-style-brand"
            onEditorStateChange={handleBrandEditorStateChange}
            onContentStateChange={handleBrandContentStateChange}
            toolbar={toolbar}
          />
        </div>
      ) : (
        <div className="campaign-discription">
          <div
            className="text"
            style={{
              paddingTop: form?.brand_instruction !== "" && "26px",
            }}
          >
            {form?.brand_instruction !== "" && "Brand Instructions"}
          </div>
          <div
            style={{
              padding: form?.brand_instruction !== "" && "30px 15px",
            }}
            dangerouslySetInnerHTML={{ __html: form?.brand_instruction }}
          />
        </div>
      )}
    </>
  );

  const termAndCondition = (
    <>
      {editable ? (
        <div className="mt-2 mb-2">
          <Editor
            editorState={terms_and_conditions_editor_state}
            toolbarClassName="editor-toolbar"
            wrapperClassName="editor-wrapper-terms-and-conditions-editor"
            // editorClassName="editor-text-area-style"
            editorClassName="editor-text-area-style-terms-privew-editor"
            onEditorStateChange={handleTermsEditorState}
            onContentStateChange={handleTermsContentState}
            toolbar={toolbarTerms}
          />
        </div>
      ) : (
        <PerfectScrollbar
          style={{
            height: "197px",
            padding: "0px 15px",
            marginTop: "25px",
            background: "white",
          }}
          className="detail-box"
          options={{ wheelPropagation: true, maxScrollbarLength: 70 }}
        >
          <div
            // className="preview-terms"
            dangerouslySetInnerHTML={{ __html: form?.terms_and_conditions }}
          />
        </PerfectScrollbar>
      )}
    </>
  );

  const Reward = (
    <>
      {editable ? (
        <>
          {" "}
          {form.campaign_reward_type !== "Other" && (
            <Input
              className="form-field reward"
              style={{ borderRadius: "0px", height: "50px", width: "150px" }}
              type="number"
              value={form.campaign_reward}
              onChange={(e) => {
                dispatch(
                  updateCampaignFields({ campaign_reward: e.target.value })
                );
              }}
            />
          )}
        </>
      ) : (
        <div className="reward">
          {form.campaign_reward_type === "Cash" && "$"}
          {form.campaign_reward_type !== "Other" && form.campaign_reward}
          {form.campaign_reward_type === "Discount" && "%"}
        </div>
      )}
    </>
  );
  const rewardOther = (
    <>
      {editable && form.campaign_reward_type === "Other" ? (
        <div>
          <Input
            placeholder="Specify the reward for your campaign participants here."
            type="textarea"
            className="form-field reward-other"
            value={form.campaign_reward}
            onChange={(e) => {
              const inputValue = e.target.value;
              const wordCount = inputValue.trim().split(/\s+/)?.length;
              if (wordCount <= 140) {
                dispatch(
                  updateCampaignFields({
                    campaign_reward: inputValue,
                  })
                );
              }
            }}
          />
        </div>
      ) : (
        <div
          className="mt-2"
          style={{ fontSize: "18px", color: "#3D3E41", width: "410px" }}
        >
          {form.campaign_reward_type === "Other" && (
            <div>{form.campaign_reward}</div>
          )}
        </div>
      )}
    </>
  );

  const formattedDate = moment(form.end_date).format("YYYY-MM-DD");
  const EndDate = (
    <>
      {editable ? (
        <div
          className="form-field"
          style={{ borderRadius: "0px", height: "50px", width: "150px" }}
        >
          <SingleDatePicker
            date={date}
            onDateChange={handleDateChange1}
            focused={focused}
            onFocusChange={handleFocusChange}
            id="your_unique_id"
            numberOfMonths={1}
            showDefaultInputIcon
            hideKeyboardShortcutsPanel
          />
        </div>
      ) : (
        <div className="date-and-time" style={{ width: "250px" }}>
          {/* {form?.ongoing ? 'Ongoing' : formattedDate} */}
          {form.ongoing ? "Ongoing" : formattedDate}
        </div>
      )}
    </>
  );
  const formattedEndTime = end_time && end_time?.format("hh:mm A");
  const Time = (
    <>
      <div className="d-flex  align-items-center mb-3">
        <div className="preview-icons">{timeIcon}</div>
        <div className="preview-heading">Time</div>
      </div>
      {editable ? (
        <div className="mb-3">
          <TimePicker
            onChange={handleTimeChange1}
            value={end_time}
            format="hh:mm a"
            placeholder="11:59 pm"
            className="form-field"
            style={{ borderRadius: "0px", height: "50px", width: "150px" }}
            use12Hours
            minuteStep={5}
            showNow={false}
            suffixIcon={""}
            needConfirm={false}
          />
        </div>
      ) : (
        <div className="date-and-time">{formattedEndTime}</div>
      )}
    </>
  );
  const timeDurationDropdown = (
    <DropdownMenu>
      <DropdownItem onClick={() => handleTimeTypeSelect("sec")}>
        <div>sec</div>
      </DropdownItem>
      <DropdownItem onClick={() => handleTimeTypeSelect("min")}>
        <div>min</div>
      </DropdownItem>
      <DropdownItem onClick={() => handleTimeTypeSelect("hr")}>
        <div>hr</div>
      </DropdownItem>
    </DropdownMenu>
  );

  const timeDurationType = (
    <div className="d-flex align-items-center justify-content-between">
      <p>
        {campaign_video_length_type ? (
          campaign_video_length_type
        ) : (
          <span className="light-text">Select</span>
        )}
      </p>
      <p>{dropdownIcon}</p>
    </div>
  );

  const campaignVideoLength = (
    <>
      <div className="d-flex  align-items-center mb-3">
        <div className="preview-icons">{timeLimiIcon}</div>
        <div className="preview-heading"> Video Length</div>
      </div>
      {editable ? (
        <div className="d-flex mb-3">
          <div>
            <Input
              className="form-field ps-1"
              style={{ borderRadius: "0px", height: "50px", width: "53px" }}
              type="number"
              id="timeInput"
              name="timeInput"
              value={form?.campaign_video_length}
              onChange={(e) => {
                dispatch(
                  updateCampaignFields({
                    campaign_video_length: e.target.value,
                  })
                );
              }}
              placeholder="3"
            />
          </div>
          <div className="ms-1 time-duration-dropdown">
            <Dropdown isOpen={dropdownOpen1} toggle={toggleTimeDropdown}>
              <DropdownToggle
                style={{
                  background: " #FFF",
                  color: "black",
                  height: "50px",
                  width: "65px",
                  borderRadius: "2px",
                  padding: "13px 8px",
                }}
              >
                {timeDurationType}
              </DropdownToggle>
              {timeDurationDropdown}
            </Dropdown>
          </div>
        </div>
      ) : (
        <div className="date-and-time">
          {`${form?.campaign_video_length} ${campaign_video_length_type}`}
        </div>
      )}
    </>
  );

  const handlePlatformChange = (value) => {
    let updatedPlatforms = [...form.campaign_upload_platform];
    if (updatedPlatforms.includes(value)) {
      updatedPlatforms = updatedPlatforms.filter(
        (platform) => platform !== value
      );
    } else {
      updatedPlatforms.push(value);
    }
    dispatch(
      updateCampaignFields({ campaign_upload_platform: updatedPlatforms })
    );
  };

  const campaignPlatforms = (
    <div>
      <div className="d-flex  align-items-center mb-3">
        <div className="preview-icons" style={{ marginTop: "-47px" }}>
          {PlatformSubmit}
        </div>
        <div className="preview-heading" style={{ marginTop: "-47px" }}>
          Video Submission
        </div>
        {!editable && (
          <div className="date-and-time">
            Share Video
            <div>
              <div className="d-flex align-items-center">
                {selectedPlatformData.map((platform, index) => (
                  <div key={index}>
                    <img
                      src={platform.icon}
                      width={25}
                      style={{ marginLeft: "10px", marginTop: "15px" }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {editable && (
          <div className="d-flex flex-wrap" style={{ width: "250px" }}>
            {platformData.map((platform, index) => (
              <div
                key={index}
                style={{
                  marginTop:
                    index === 3 || index === 4 || index === 5 ? "20px" : "10px",
                }}
              >
                <label>
                  <input
                    type="checkbox"
                    style={{ marginTop: "10px" }}
                    onChange={() => handlePlatformChange(platform.name)}
                    checked={form.campaign_upload_platform?.includes(
                      platform.name
                    )}
                  />
                  <img
                    src={platform.icon}
                    width={30}
                    style={{ marginLeft: "6px", marginRight: "30px" }}
                  />
                </label>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  const dispatch = useDispatch();
  const styles = {
    marginLeft: "25px",
    marginTop: "35px",
    color: "#783AD0",
    fontSize: "20px",
    display: "flex",
    alignItems: "center",
  };

  return (
    <div className="form-step-4">
      {!showCampaignStep && <Step4EditModal />}
      <Step4InfoModal
        open={open}
        toggle={toggle}
        handleSubmit={handleSubmit}
        loading={loading}
      />
      <FormStep4QRModal open={qrModal} toggle={closeQrModal} />
      <QrCodeModal open={qrmodal} handleCloseQr={handleCloseQr} />
      <div className="d-flex justify-content-center mb-5">
        <div
          className="main-container"
          style={{
            border: " 1px solid #000",
            background: `${
              form?.preview_color_change
                ? form?.preview_color_change
                : "#526261"
            }`,
          }}
        >
          {/* <div className="brand-logo">FRESHLY LOGO</div> */}

          {editable && (
            <div className="color-change">
              <div
                role="button"
                className="background-color"
                onClick={() => setIsColorPickerOpen(true)}
              >
                <div className="text">Background Color</div>
                <div
                  className="color"
                  style={{
                    background: `${
                      form?.preview_color_change
                        ? form?.preview_color_change
                        : "#526261"
                    }`,
                  }}
                ></div>
              </div>
              <div style={{ position: "absolute", zIndex: "2" }}>
                {isColorPickerOpen && (
                  <div ref={pickerRef}>
                    <ReactGPicker
                      value={
                        form?.preview_color_change
                          ? form?.preview_color_change
                          : "#526261"
                      }
                      onChange={onColorChange}
                      showAlpha={false}
                    />
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="my-5">
            <img
              src={form.campaign_brand_image_preview}
              alt=""
              style={{ maxWidth: "150px" }}
            />
          </div>
          {/* head line */}
          {headline}
          {/* hashtags */}
          {hashtags}
          {/* product image */}
          {productimage}

          {/* discription */}
          <div
            style={{
              width: "547px",
              background: "white",
              paddingLeft: "60px",
              borderRadius: "20px",
              marginTop: "40px",
              boxShadow: "0px 4px 10px 0px #00000040",
            }}
          >
            {editable || form.campaign_reward !== "" ? (
              <>
                <div className="d-flex mt-3">
                  <div className="d-flex align-items-center">
                    <div className="preview-icons">{rewardIcon}</div>
                    <div className="reward preview-heading">Reward</div>
                  </div>
                  {Reward}
                  {"  "}
                  {/* {form.campaign_reward_type === "Discount" &&
                  form.campaign_reward !== "" ? (

                    <span className="reward" style={{ marginLeft: "7px" }}>
                      %
                    </span>
                  ) : (
                    ""
                  )} */}
                </div>
                {rewardOther}
              </>
            ) : null}

            <div className="d-flex mt-3 mb-3">
              <div className="d-flex align-items-center">
                <div className="preview-icons">{calenderIcon}</div>
                <div className="preview-heading">End Date</div>
              </div>
              {EndDate}
            </div>

            <div className="d-flex">
              {editable || end_time !== "" ? Time : null}
            </div>
            <div className="d-flex">
              {editable ||
              (form.campaign_video_length !== "" &&
                campaign_video_length_type !== "")
                ? campaignVideoLength
                : null}
            </div>
            <div>
              {editable || form?.campaign_upload_platform.length !== 0
                ? campaignPlatforms
                : null}
            </div>
          </div>
          {discriptions}
          {brandInstructions}

          <section className="t-and-c-section">
            <h2 className="form-field-label">Terms and Conditions</h2>
            {termAndCondition}

            <div className="d-flex align-items-center">
              <input
                type="checkbox"
                defaultChecked
                style={{ width: "18px", height: "18px", marginRight: "20px" }}
              />
              <span>I agree to the Terms and Conditions</span>
            </div>
          </section>

          <div className="d-flex mt-5">
            <div className="center upload-button ">
              <button
                className="btn  campaign-button"
                style={{
                  width: "197px",
                  height: "56px",
                  color: `${form?.campaign_button_text_color}`,
                  background: `${form?.campaign_button_color || "#96C392"}`,
                }}
              >
                Upload Video
              </button>
            </div>
            {editable && (
              <div role="button">
                <div
                  className="button-color"
                  style={{
                    marginBottom: "4px",
                  }}
                  onClick={() => setIsColorPickerButton(true)}
                >
                  <div
                    className="button-picker"
                    style={{
                      background: `${form?.campaign_button_color || "#96C392"}`,
                    }}
                  ></div>
                </div>
                <div style={{ position: "absolute", zIndex: "2" }}>
                  {isColorPickerButton && (
                    <div ref={pickerRef}>
                      <ReactGPicker
                        value={form?.campaign_button_color || "#96C392"}
                        onChange={onButtonColorChange}
                        showAlpha={false}
                      />
                    </div>
                  )}
                </div>
                <div
                  className="button-color"
                  onClick={() => setIsColorPickerButtonText(true)}
                >
                  <img
                    src={
                      require(`@src/assets/images/colorPickerIcon.png`).default
                    }
                    width={18}
                  />
                </div>
                <div style={{ position: "absolute", zIndex: "2" }}>
                  {isColorPickerButtonText && (
                    <div ref={pickerRef}>
                      <ReactGPicker
                        value={form?.campaign_button_text_color}
                        onChange={onButtonTextColorChange}
                        showAlpha={false}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        {!editable && showCampaignStep && (
          <div>
            <div
              onClick={handleCopyClick}
              role="button"
              style={{ ...styles, marginTop: "0px" }}
            >
              <span style={{ marginRight: "10px" }}>{copyIcon}</span>
              {copied ? "Copied" : "Copy Link"}
            </div>
            <div
              onClick={() => {
                if (campaign_response?.generate_qr === "Generated") {
                  handleQrClick();
                } else {
                  setQrmodal(true);
                }
              }}
              role="button"
              style={styles}
            >
              <span style={{ marginRight: "10px" }}>{qrCodeIcon}</span>
              {"QR Code"}
            </div>
            <div onClick={editHandler} role="button" style={styles}>
              <span style={{ marginRight: "10px", marginBottom: "3px" }}>
                {editIcon}
              </span>{" "}
              {"Edit Campaign"}
            </div>
          </div>
        )}
      </div>
      {editable && (
        <div
          className="done mt-1"
          onClick={editHandler}
          role="button"
          style={{ marginBottom: editable && "200px", float: "right" }}
        >
          Save
        </div>
      )}
      {!editable && !showCampaignStep && (
        <div className="center mt-5 mb-5">
          <Button
            className="campaign-button"
            size="lg"
            onClick={() => setOpen(true)}
            disabled={open}
            color={`${open} ? secondary : primary`}
            style={{ background: open ? "#C4C4C4" : "" }}
          >
            Next
          </Button>
        </div>
      )}
    </div>
  );
};

export default FormStep4;
